import { api } from ".";

// Define the response type for analytics data
interface IAnalyticsResponse {
  data: {
    iframeUrl: string;
  };
}

// Create analytics query endpoints
const analyticsQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getAnalyticsUrl: builder.query<IAnalyticsResponse, { accountId?: string }>({
      query: ({ accountId }) =>
        accountId
          ? `accounts/analytics?accountId=${accountId}`
          : "accounts/analytics",
    }),
    getClaimsAnalysisUrl: builder.query<
      IAnalyticsResponse,
      { accountId: string }
    >({
      query: ({ accountId }) =>
        `accounts/claims-analysis?accountId=${accountId}`,
    }),
  }),
});

export const { useGetAnalyticsUrlQuery, useGetClaimsAnalysisUrlQuery } =
  analyticsQueries;
